import React from 'react'
import {Modal, Button, ListGroup} from "react-bootstrap"
const ModalCandidatos = (props) => {
  const {show, setShow, votacion} = props
  return (
		<Modal
			show={show}
			onHide={() => setShow(false)}
			backdrop="static"
			keyboard={false}
			className="text-center"
		>
			<Modal.Header closeButton>
				<Modal.Title>Candidatos {votacion?.nombre}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="px-2 py-4">
        <ListGroup variant="flush">

       {
         votacion?.candidatos?.map(x=>{
           return (
            <ListGroup.Item>{x.nombre || x}</ListGroup.Item> 
             )
            })
          }
          </ListGroup>

			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="secondary"
					block
					onClick={() => {
						setShow(false)
					}}
				>
					Volver
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default ModalCandidatos
